import React from "react";
import Logo from "./components/TopSection/TopSection";
import OperatingArea from "./components/OperatingArea/OperatingArea";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Logo />
      <OperatingArea />
      <Footer />
    </>
  );
}

export default App;
